import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getAiSummaryS3 } from "../connections/getApi";
import {
  setDoctorOption,
  setError,
  setLoading,
} from "../redux/slices/appointmentSlice";

const UseFetchAiSummaryS3 = (type, resourceId, resourceType) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["getAiSummaryS3", type, resourceId, resourceType],
    queryFn: () => getAiSummaryS3(type, resourceId, resourceType),
    enabled: !!type && !!resourceId && !!resourceType,
    onError: (error) => {
      console.error("Error in UseFetchAiSummaryS3:", error);
      dispatch(setError(true));
      dispatch(setLoading(false));
    },
    onSuccess: (data) => {
      dispatch(setDoctorOption(data));
      console.log("Successfully fetched doctor list:", data);
    },
    onSettled: () => {
      dispatch(setLoading(false));
    },
    // staleTime: Infinity, // Keep the data fresh indefinitely
    // cacheTime: 1000 * 60 * 60, // Cache the data for 1 hour
    // refetchOnWindowFocus: false, // Don't refetch when window regains focus
    // refetchOnReconnect: false, // Don't refetch when reconnecting
    // refetchOnMount: false, // Don't refetch on component mount
  });
};

export default UseFetchAiSummaryS3;
